import { Injectable } from '@angular/core';
import { LMContextService, LMMessageWrapperDialogRef, LMModalDialogWrapperRef } from '@app/services';

@Injectable()
export class LMModalOpenService {

  constructor(
      private lmContextService: LMContextService) {
  }

  private openModals = new Array<LMDialogInfo>();

  get hasOpenModals(): boolean {
    return this.openModals.length > 0;
  }

  public addModal(uuid: number, modalRef: LMModalDialogWrapperRef<any> | LMMessageWrapperDialogRef): void {
    const wasEmpty = this.openModals.length === 0;
    this.openModals.push({ uuid, dialogRef: modalRef });

    if (wasEmpty) {
      this.firstModalOpened();
    }
  }

  public removeModal(uuid: number): void {
    if (this.openModals.length === 0) {
      return;
    }

    let closedIndex = -1;
    this.openModals.forEach((dialogInfo: LMDialogInfo, index: number) => {
      if (dialogInfo.uuid === uuid) {
        closedIndex = index;
      }
    });

    if (closedIndex > -1) {
      this.openModals.splice(closedIndex, 1);
      
      if (this.openModals.length === 0) {
        this.lastModalClosed();
      }
    }
  }

  public closeLastModal(): void {
    if (this.openModals.length === 0) {
      return;
    }

    const dialog = this.openModals[this.openModals.length - 1];
    if (dialog?.dialogRef) {
      dialog.dialogRef.close();
    }
  }

  public get lastModalRef(): LMModalDialogWrapperRef<any> | LMMessageWrapperDialogRef | undefined {
    if (this.openModals.length === 0) {
      return undefined;
    }
    return this.openModals[this.openModals.length - 1]?.dialogRef;
  }

  public closeAllModals(): void {
    if (this.openModals.length === 0) {
      return;
    }

    while (this.openModals.length > 0) {
      const dialog = this.openModals.pop();
      if (dialog && dialog.dialogRef) {
        dialog.dialogRef.close();
      }
    }
    this.openModals = [];
    this.lastModalClosed();
  }

  private firstModalOpened(): void {
    if (this.lmContextService.insideInforMobileHub()) {
      // hide bottom bar in infor mobile app
      const data = { state: '0' }; // '0' means hide, '1' means show
      infor.companyon.client.sendMessage('mobile_setTheBottomBarState', data);
    }
  }

  private lastModalClosed(): void {
    if (this.lmContextService.insideInforMobileHub()) {
      // show bottom bar in infor mobile app
      const data = { state: '1' }; // '0' means hide, '1' means show
      infor.companyon.client.sendMessage('mobile_setTheBottomBarState', data);
    }
  }
}

interface LMDialogInfo {
  uuid: number;
  dialogRef: LMModalDialogWrapperRef<any> | LMMessageWrapperDialogRef;
}
